var Flickity = require('flickity');
require('flickity-imagesloaded');
import 'flickity/css/flickity.css'
import Responsive from '../tools/responsive';

export default class Carousel {
  constructor(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    if(element !== null && element !== ''){
      this.initialConfig = JSON.parse(element.getAttribute('data-flickity-config'));
    }
    this.options = options;

    this._attachListeners();
    this._build();
  }

  destroy() {
    this.flickityInstance.destroy();
    if (this.initialConfig['breakpoints'] !== undefined) {
      document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }
  }
  selectCell(index) {
    var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (shouldPause) {
      this.flickityInstance.pausePlayer();
    }

    this.flickityInstance.select(index, false, !shouldAnimate);
  }
  pausePlayer() {
    this.flickityInstance.pausePlayer();
  }
  unpausePlayer() {
    this.flickityInstance.unpausePlayer();
  }
  resize() {
    this.flickityInstance.resize();
  }
  getSelectedIndex() {
    return this.flickityInstance.selectedIndex;
  }
  getSelectedCell() {
    return this.flickityInstance.selectedCell.element;
  }
  _attachListeners() {
    if (this.initialConfig['breakpoints'] !== undefined) {
      this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
      document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }
  }

  /**
   * Create the carousel instance
   */

  _build() {
    var _this = this;

    var config = this._processConfig();

    this.flickityInstance = new Flickity(this.element, config);

    this.selectedIndex = this.flickityInstance.selectedIndex;
    
    if (this.options['onSelect']) {
      this.flickityInstance.on('select', function () {
        // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
        // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)

        if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
          _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
          _this.selectedIndex = _this.flickityInstance.selectedIndex;
        }
      });
    }

    if (this.options['onClick']) {
      this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
        _this.options['onClick'](cell, index);
      });
    }
  }

  /**
   * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
   * if the displayed elements equals to the amount of elements
   */

  _validateDraggable() {
    var isActive = this.flickityInstance.isActive || false;
    this.resize.bind(this);
    if (!isActive || !this.flickityInstance.options['draggable']) {
      return; // Not draggable, so nothing to do
    }
    this.flickityInstance.dragMove();
  }

  /**
   * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
   */

  _processConfig() {
    var config = Object.assign({}, this.initialConfig);

    delete config['breakpoints'];

    if (this.initialConfig['breakpoints'] === undefined) {
      return config; // No change, we simply return the config as it is
    }

    var breakpoints = this.initialConfig['breakpoints'];

    breakpoints.forEach(function (breakpoint) {
      if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
        config = Object.assign(config, breakpoint['settings']);
      }
    });

    return config;
  }

  /**
   * Verify if the breakpoint has changed, and optionally update the carousel
   */

  _onBreakpointChanged() {
    // The breakpoint may have changed, so we delete the carousel and rebuild it
    this.flickityInstance.destroy();
    this._build();
  }
}